import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

interface FilterLayoutProps {
  title: string;
  onClear: () => void;
  showHeader?: boolean;
  children: React.ReactNode;
  id?: string;
  refProp?: React.Ref<any>;
  sx?: SxProps<Theme>;
}

export const FilterLayout: React.FC<FilterLayoutProps> = ({
  title,
  onClear,
  showHeader = true,
  children,
  id,
  refProp,
  sx,
}) => (
  <Box id={id} ref={refProp} sx={sx}>
    {showHeader && (
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Typography variant="h5">{title}</Typography>
        <Button size="medium" variant="text" onClick={onClear}>
          Clear
        </Button>
      </Stack>
    )}
    {children}
  </Box>
);
